/// <reference path="../typings/index.d.ts" />
namespace App {
    export class BotaoIncrementDecrementEa {
        private elBtIncrement: JQuery = $(".increment");
        private elBtDecrement: JQuery = $(".decrement");

        public inicializarEventos() {
            var timer: number = 0;
            this.elBtIncrement.on('click', (e) => { this.aoIncrementarValor(e); });
            this.elBtDecrement.on('click', (e) => { this.aoDecrementarValor(e); });
            this.elBtIncrement.on("mousedown", (e) => {
                timer = setInterval(() => {
                    this.aoIncrementarValor(e);
                }, 120);
            }).on("mouseup mouseleave", () => {
                clearInterval(timer);
            });
            this.elBtDecrement.on("mousedown", (e) => {
                timer = setInterval(() => {
                    this.aoDecrementarValor(e);
                }, 120);
            }).on("mouseup mouseleave", () => {
                clearInterval(timer);
            });
        }

        private aoIncrementarValor(e: JQueryEventObject) {
            var campoValor = $(e.currentTarget).parents('.input-group').find('input');
            var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min')
            if (App.Util.ehCampoTextoVazio(campoValor)) {
                campoValor.val(campoValorMin).trigger('input').trigger('focusout').trigger('change');
                return;
            }

            var valor = App.Util.obterInteiroDaString(campoValor.val());
            if (!$.isNumeric(valor)) {
                return;
            }
            var campoValorIncrementado = App.Util.incrementarValorDeFiltro(valor);
            campoValor.val(campoValorIncrementado).trigger('input').trigger('focusout').trigger('change');
        }

        private aoDecrementarValor(e: JQueryEventObject) {
            var campoValor = $(e.currentTarget).parents('.input-group').find('input');
            var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
            var valor = App.Util.obterInteiroDaString(campoValor.val());
            if (!$.isNumeric(valor)) {
                return;
            }

            if (valor <= campoValorMin) {
                campoValor.val('').trigger('input').trigger('focusout').trigger('change');;
                return;
            }

            var campoValorDecrementado = App.Util.decrementarValorDeFiltro(valor);
            campoValor.val(campoValorDecrementado).trigger('input').trigger('focusout').trigger('change');;
        }




    }
}
